import React, { Component } from 'react';
// import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Form, FormGroup, Button } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import FontAwesome from 'react-fontawesome';
import ReportStore from '../../stores/ReportStore';
import PickupRecord from '../pu/PickupRecord'
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'

// var NotificationSystem = require('react-notification-system');
const yTh = parseInt(Moment().format('YYYY')) + 543
class ReportPickup extends Component {
  constructor(props) {
    super(props)

    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    this.state = {
      loading:false,
      showTb:true,
      optionsYear:optionsYear,
      defaultYear:yTh,
      optionsEmp:[],
      defaultEmp:'',
      data:[],
      monthSelect:0,
      displayTb:'',
      displayBar:'none',
      btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>),
      btnAction:'barchart',
      isSubMenu:false,
      subMenu:[]
    }
    this.barChart = null
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&newProps.show!=this.props.show)
      this.loadStockRequesterList(this.state.defaultYear)
  }

  setBarChart(dataSet=false) { 
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar

    let {data} = this.state
    if (!dataSet)
      dataSet = data

    let labels = []
    let data_barchart = []
    let data_year = [0,0,0,0,0,0,0,0,0,0,0,0]
    let i = 0
    let January = 'มกราคม'
    let February = 'กุมภาพันธ์'
    let March = 'มีนาคม'
    let April = 'เมษายน'
    let May = 'พฤษภาคม'
    let June = 'มิถุนายน'
    let July = 'กรกฎาคม'
    let August = 'สิงหาคม'
    let September = 'กันยายน'
    let October = 'ตุลาคม'
    let November = 'พฤศจิกายน'
    let December = 'ธันวาคม'
    labels = [January,February,March,April,May,June,July,August,September,October,November,December]
    dataSet.forEach(function(item,index) {
      data_year[index] = parseFloat(data_year[index]) + parseFloat(item.cost_stock)
    })
    data_barchart = data_year
    if(this.barChart!=null){
      this.barChart.destroy();
    }
    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: [{
              label: 'ต้นทุนสินค้า',
              data: data_barchart,
              backgroundColor: 'green'
          }]
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero:true
                  }
              }]
          }
      }
    });
  }

  getMonthText(month) {
    if (month==='1'||month===1)
      return 'มกราคม'
    else if (month==='2'||month===2)
      return 'กุมภาพันธ์'
    else if (month==='3'||month===3)
      return 'มีนาคม'
    else if (month==='4'||month===4)
      return 'เมษายน'
    else if (month==='5'||month===5)
      return 'พฤษภาคม'
    else if (month==='6'||month===6)
      return 'มิถุนายน'
    else if (month==='7'||month===7)
      return 'กรกฎาคม'
    else if (month==='8'||month===8)
      return 'สิงหาคม'
    else if (month==='9'||month===9)
      return 'กันยายน'
    else if (month==='10'||month===10)
      return 'ตุลาคม'
    else if (month==='11'||month===11)
      return 'พฤศจิกายน'
    else if (month==='12'||month===12)
      return 'ธันวาคม'
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = (item[key]===''||item[key]===null||item[key]===undefined||isNaN(item[key])?0:item[key])
      sum += parseFloat(value)
    })
    return sum
  }

  newEmptyRow(number=1) {
    return new Array(number).fill(null).map((item,index)=>{
      return {month:index+1,name:'',cost_stock:''}
    })
  }

  loadStockRequesterList(year) {
    let optionsEmp = []
    optionsEmp.push({label:'--- เลือก ---',value:''})
    ReportStore.loadStockRequesterList(year,(result)=> {
      result.data.forEach(function(item,index) {
        optionsEmp.push({
          label:item.name,
          value:item.name
        })
      })
      this.setState({optionsEmp:optionsEmp})
    })
  }

  loadEmpStock(year,name) {
    this.setState({loading:true})
    ReportStore.loadEmpStock(year,name,(result)=> {
      this.setState({data:result.data,loading:false})
      if (this.state.btnAction==='report')
        this.setBarChart(result.data)
    })
  }

  onYearChange(e) {
    let {defaultEmp} = this.state
    this.setState({defaultYear:e.value})
    this.loadEmpStock(e.value,defaultEmp)
  }

  onEmpChange(e) {
    let {defaultYear} = this.state
    this.setState({defaultEmp:e.value})
    this.loadEmpStock(defaultYear,e.value)
  }

  onRowSelect(year,month,name) {
    this.setState({showTb:false,monthSelect:month,subMenu:[{title:name+' ประจำปี '+year+' เดือน '+this.getMonthText(month),key:'s'+0}],isSubMenu:true},()=>{
      if (this.props.onUpdateEventKey!=undefined)
        this.props.onUpdateEventKey('s'+0)
    })
    this.refs.pickupRecord.loadPickupRecord(year,month,name)
  }

  onReportClose() {
    this.setState({showTb:true,monthSelect:0})
  }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,showTb:true,monthSelect:0})
    if (this.props.onUpdateEventKey!=undefined)
      this.props.onUpdateEventKey(undefined)
  }

  onBarChartClick(action,e) {
    let {displayTb,displayBar,btnBar,btnAction,defaultYear,defaultEmp} = this.state
    let new_action = ''
    if (action=='barchart') {
      new_action = 'report'
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;ดูรายงาน</div>)})
      this.loadEmpStock(defaultYear,defaultEmp)
      this.setBarChart()  
    } else {
      new_action = 'barchart'
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>)})
      this.loadEmpStock(defaultYear,defaultEmp)
    }
  }

  renderRowData() {
    let {data,defaultYear} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={5}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=> {
          return(
            <tr key={index}>
              <td onClick={this.onRowSelect.bind(this,defaultYear,item.month,item.name)} className='text-center'>{index+1}</td>
              <td onClick={this.onRowSelect.bind(this,defaultYear,item.month,item.name)} className='text-center'>{this.getMonthText(item.month)}</td>
              <td onClick={this.onRowSelect.bind(this,defaultYear,item.month,item.name)} className='text-center'>{item.name}</td>
              <td onClick={this.onRowSelect.bind(this,defaultYear,item.month,item.name)} className='text-center'>{this.getNumberFormat(item.quantity)}</td>
              <td onClick={this.onRowSelect.bind(this,defaultYear,item.month,item.name)} className='text-right'>{this.getNumberFormat(item.cost_stock)}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable() {
    return(
      <div className='table-responsive'>
        <table className='table table-responsive table-hover table-bordered-solid table-tool' style={{marginBottom:'0'}}>
            <thead>
              <tr>          
                <th className='text-center' style={{ width: '5%' }}>ลำดับ</th>
                <th className='text-center' style={{ width: '15%' }}>เดือน</th>
                <th className='text-center' style={{ width: '55%' }}>ชื่อพนักงาน</th>
                <th className='text-center' style={{ width: '10%' }}>จำนวนรายการ</th>
                <th className='text-center' style={{ width: '15%' }}>ต้นทุนสินค้าทั้งหมด</th>
              </tr>  
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <tfoot>
              <tr>          
                <th className='text-center' colSpan={3}></th>
                <th className='text-center'>{this.getNumberFormat(this.getSummary('quantity'))}</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('cost_stock'))}</th>
              </tr>  
            </tfoot>
        </table>
      </div>
    )  
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  render() {
    let {loading,showTb} = this.state
    let {report} = this.props
    return(
      <div>
        <div style={{display:(showTb?'':'none')}}>
          <Box loading={loading}>           
            <Box.Header border={true}>          
              {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
            </Box.Header>            
            <Box.Body>
              <Form inline>
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultYear }
                    options={this.state.optionsYear}
                    style={{ width: '80px' }}
                    onChange={ this.onYearChange.bind(this) }
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultEmp }
                    options={this.state.optionsEmp}
                    style={{ width: '200px' }}
                    onChange={ this.onEmpChange.bind(this) }
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Button
                  className='btn-primary'
                  onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
                  >
                    {this.state.btnBar}
                  </Button>
                </FormGroup>
              </Form>
              {report=='ReportPage'?<br/>:''}
              <div style={{display:this.state.displayTb}} style={{marginTop:(report=='ReportCategoryPage'?'5px':'')}}>
                {this.renderTable()}
              </div>
              <div style={{display:this.state.displayBar}}>
                {this.renderBarChat()}
              </div>  
            </Box.Body>
          </Box>     
        </div>
        <div style={{display:(showTb?'none':'')}}>
          <PickupRecord
            ref={'pickupRecord'}
            report={this.props.report}
            isReport={true}
            onReportClose={this.onReportClose.bind(this)}
            year={this.state.defaultYear}
            month={this.state.monthSelect}
            requestBy={this.state.defaultEmp}
            onTableDetailCloseClick={this.onTableDetailCloseClick.bind(this)}
            renderMenu={this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
          />
        </div>   
      </div>
    )
  }
}

ReportPickup.defaultProps = {
  report:'ReportPage'
}

export default ReportPickup;  


// WEBPACK FOOTER //
// ./src/view/report/ReportPickup.js